import React, { useEffect } from 'react';
import './AutoSaveToast.css';

/**
 * Lightweight auto-dismissing notice for background saves (not for explicit user "Save" clicks).
 */
const AutoSaveToast = ({
  open,
  onClose,
  variant = 'success',
  message,
  duration = 5000
}) => {
  useEffect(() => {
    if (!open || duration <= 0) return undefined;
    const t = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(t);
  }, [open, duration, onClose]);

  if (!open || !message) return null;

  const icon = variant === 'error' ? '!' : '✓';

  return (
    <div
      className={`auto-save-toast auto-save-toast--${variant === 'error' ? 'error' : 'success'}`}
      role="status"
      aria-live="polite"
    >
      <span className="auto-save-toast__icon" aria-hidden="true">
        {icon}
      </span>
      <span className="auto-save-toast__text">{message}</span>
      <button
        type="button"
        className="auto-save-toast__dismiss"
        onClick={onClose}
        aria-label="Dismiss notification"
      >
        ×
      </button>
    </div>
  );
};

export default AutoSaveToast;
